"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingDetailsLegacyFetcher = void 0;
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var legacy_queries_1 = require("../../../shared/api/legacy-queries");
var mappings_1 = require("../../../shared/api/mappings");
var core_1 = require("../../../shared/core");
var Error_1 = require("../components/Error");
var Loading_1 = require("../components/Loading");
var ui_1 = require("../pages/BillingDetails/ui");
var mapBillingLegacyResponseToBillingDetailsCX = function (data) {
    if (!data.billingSummary) {
        return null;
    }
    if ('latestPeriod' in data.billingSummary) {
        return data.billingSummary.latestPeriod.data;
    }
    return data.billingSummary.billablePeriod.data;
};
var Data = function (_a) {
    var billingResponse = _a.billingResponse, supplyPointsResponse = _a.supplyPointsResponse, meterReadingsResponse = _a.meterReadingsResponse, period = _a.period, kapiReads = _a.kapiReads;
    var data = mapBillingLegacyResponseToBillingDetailsCX(billingResponse);
    var isLatestPeriod = !data ||
        ((billingResponse === null || billingResponse === void 0 ? void 0 : billingResponse.billingSummary) &&
            'latestPeriod' in billingResponse.billingSummary &&
            (0, date_fns_1.isBefore)(data.end, (0, date_fns_1.format)(new Date(), 'yyyy-MM-dd')) &&
            period === 'latest');
    return (react_1.default.createElement(ui_1.BillingDetailsUI, { data: data, isLatestPeriod: isLatestPeriod, supplyPointsResponse: supplyPointsResponse, meterReadingsResponse: meterReadingsResponse, kapiReads: kapiReads }));
};
function BillingDetailsLegacyFetcher(_a) {
    var accountId = _a.accountId, period = _a.period;
    var _b = core_1.configService.getConfig(), retailer = _b.retailer, kapi = _b.kapi;
    var kapiEnabled = retailer.region === 'UK' ? kapi && (kapi === null || kapi === void 0 ? void 0 : kapi.billingReads) : true;
    var billingQueryResult = (0, legacy_queries_1.useBillingLegacyQuery)(accountId, period);
    var _c = (0, legacy_queries_1.useSupplyPoints)(accountId), data = _c.data, error = _c.error, loading = _c.loading;
    var meterReadingsQueryResult = (0, legacy_queries_1.useMeterReadingsLegacyQuery)(accountId, {
        enabled: !kapiEnabled,
    });
    var _d = (0, mappings_1.useMeterReads)(accountId, !kapiEnabled), kapiReadsData = _d.data, kapiReadsLoading = _d.loading, kapiReadsError = _d.error;
    var _e = __read(kapiEnabled
        ? [kapiReadsData, kapiReadsLoading, !!kapiReadsError]
        : [
            meterReadingsQueryResult.status === 'data'
                ? meterReadingsQueryResult.data
                : undefined,
            meterReadingsQueryResult.isFetching,
            meterReadingsQueryResult.status === 'error',
        ], 3), readsData = _e[0], readsLoading = _e[1], hasReadsError = _e[2];
    var isLoading = loading ||
        billingQueryResult.isFetching ||
        readsLoading ||
        !data ||
        billingQueryResult.status === 'no-data' ||
        !readsData;
    if (isLoading) {
        return react_1.default.createElement(Loading_1.FetchBillingDetailsLoading, null);
    }
    var hasError = error || billingQueryResult.status === 'error' || hasReadsError;
    if (hasError) {
        return react_1.default.createElement(Error_1.Error, null);
    }
    return (react_1.default.createElement(Data, { period: period, billingResponse: billingQueryResult.data, meterReadingsResponse: readsData, supplyPointsResponse: data, kapiReads: !!kapiEnabled }));
}
exports.BillingDetailsLegacyFetcher = BillingDetailsLegacyFetcher;
